import React from 'react';
import { Modal, Button } from "@forge/common";
import { CREATE_COURSE_CONSTANTS } from "../utils/constants";

interface PowerOffConfirmationModalProps {
    isOpen: boolean;
    vmName?: string;
    onClose: () => void;
    onConfirm: () => void;
}

const PowerOffConfirmationModal: React.FC<PowerOffConfirmationModalProps> = ({
    isOpen,
    vmName,
    onClose,
    onConfirm
}) => {
    if (!isOpen) return null;

    return (
        <Modal
            backdrop={true}
            className="cancel-confirmation-modal border border-[#E0E0E0] border-[0.2px]"
            footerLeft={
                <div className="flex justify-center">
                    <Button
                        className="cancel-modal-btns mr-4 w-full"
                        id="power-off-cancel"
                        data-testid="power-off-cancel"
                        onClick={onClose}
                        size="regular"
                        variant="secondary"
                    >
                        {CREATE_COURSE_CONSTANTS.POWER_OFF_CONFIRMATION_MODAL.BUTTONS.CANCEL}
                    </Button>
                    <Button
                        className="cancel-modal-btns w-full"
                        id="power-off-confirm"
                        data-testid="power-off-confirm"
                        onClick={onConfirm}
                        size="regular"
                        variant="primary"
                    >
                        {CREATE_COURSE_CONSTANTS.POWER_OFF_CONFIRMATION_MODAL.BUTTONS.YES}
                    </Button>
                </div>
            }
            onModalClose={onClose}
            title={
                CREATE_COURSE_CONSTANTS.POWER_OFF_CONFIRMATION_MODAL.TITLE
            }
        >
            <div className="xl-low:!text-sm xl-mid:!text-base xl-high:!text-lg">
                {CREATE_COURSE_CONSTANTS.POWER_OFF_CONFIRMATION_MODAL.MESSAGE} <strong>{vmName}</strong> ?
            </div>
        </Modal>
    );
};

export default PowerOffConfirmationModal;